import React from 'react';
import Modal from 'react-bootstrap/Modal';
import PillButton from 'components/atoms/pill_button';

interface AmbassadorJoinConfirmProps {
  show: boolean;
  sending: boolean;
  failed: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const AmbassadorJoinConfirm: React.FC<AmbassadorJoinConfirmProps> = ({
  show,
  sending,
  failed,
  onCancel,
  onConfirm,
}) => {
  const close = () => {
    if (!sending) onCancel();
  };

  return (
    <Modal show={show} centered onHide={close} aria-labelledby="ambassador-join-confirm-title">
      <div className="modal-header">
        <h5 id="ambassador-join-confirm-title" className="modal-title">
          <strong>Confirmar participação</strong>
        </h5>
        <button
          aria-label="Fechar"
          className="close"
          type="button"
          onClick={close}
          disabled={sending}
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div className="modal-body">
        <p className="text-center mb-0 py-3">
          Você vai entrar para o time de Embaixadores do ConLicitação e poderá testar as novas
          ferramentas antes do lançamento. Deseja confirmar a sua participação?
        </p>
        {failed && (
          <div className="alert alert-danger text-center mb-0" role="alert">
            Não foi possível confirmar a sua participação agora. Tente novamente.
          </div>
        )}
      </div>
      <div className="modal-footer justify-content-center">
        <button type="button" className="btn btn-light border" onClick={close} disabled={sending}>
          Cancelar
        </button>
        <PillButton onClick={onConfirm} disabled={sending}>
          {sending ? 'Confirmando...' : 'Confirmar'}
        </PillButton>
      </div>
    </Modal>
  );
};

export default AmbassadorJoinConfirm;
